import { DiffEditor } from "@monaco-editor/react";
import { useRef } from "react";
import { X } from "lucide-react";

function SolutionDiffModal({ isOpen, onClose, userCode, solutionCode }) {
  const editorRef = useRef(null);

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
  }

  function handleEditorBeforeMount(monaco) {
    let theme = {
      base: "vs-dark",
      inherit: true,
      rules: [{ token: "type", foreground: "569cd6" }],
      colors: {},
    };
    monaco.editor.defineTheme("my-theme", theme);
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-zinc-900 rounded-lg shadow-2xl border border-zinc-700/50 w-full max-w-6xl mx-4 max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-zinc-700/50">
          <h3 className="text-lg font-semibold text-transparent bg-clip-text bg-gradient-to-r from-lime-400 to-cyan-400">
            Solution Comparison
          </h3>
          <button
            onClick={onClose}
            className="text-zinc-400 hover:text-white transition-colors p-1 rounded-md hover:bg-zinc-700/50"
          >
            <X size={20} />
          </button>
        </div>

        {/* Column Headers */}
        <div className="grid grid-cols-2 gap-4 text-center py-3 px-4 bg-zinc-800/50 border-b border-zinc-700/50">
          <div className="text-sm font-medium text-zinc-300">Your Submission</div>
          <div className="text-sm font-medium text-zinc-300">Solution</div>
        </div>

        {/* Diff Editor */}
        <div className="flex-1 min-h-0 p-4">
          <DiffEditor
            className="inline-block"
            height="50vh"
            onMount={handleEditorDidMount}
            beforeMount={handleEditorBeforeMount}
            defaultLanguage="apex"
            theme="my-theme"
            original={userCode || ""}
            modified={solutionCode || ""}
            options={{
              fontSize: "14px",
              minimap: {
                enabled: false,
              },
              scrollbar: {
                alwaysConsumeMouseWheel: false,
              },
              scrollBeyondLastLine: false,
              readOnly: true,
            }}
          />
        </div>

        {/* Footer */}
        <div className="flex justify-end p-4 border-t border-zinc-700/50">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-zinc-700 hover:bg-zinc-600 text-white rounded-md transition-colors text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default SolutionDiffModal;
